module.exports = __webpack_public_path__ + "static/img/20231208_02.a88ec07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231208_02.png
// module id = QxT7
// module chunks = 0